'use client';

import { useLocaleRoutes } from '@/src/utils/useLocaleRoutes';
import LoadingBlock from '@components/loadingSkeletons/loadingBlock';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFoundPage() {
  const t = useTranslations('page.notFound');
  const pathname = usePathname();
  const pathnames = pathname.split('/');
  const path = useLocaleRoutes();
  const ifRedirect =
    pathnames.length === 3 &&
    pathnames[1] !== 'item' &&
    pathnames[1] !== path('item') &&
    pathnames[2] === String(parseInt(pathnames[2]));
  const { push } = useRouter();

  useEffect(() => {
    if (ifRedirect) {
      push(`/${pathnames[1]}/${path('item')}/${pathnames[2]}`);
    }
  });

  if (ifRedirect) {
    return <LoadingBlock />;
  }

  return (
    <div>
      <h1 className='mb-10 border-b border-white pb-4 text-3xl font-semibold uppercase'>
        {t('title')}
      </h1>
      <p>{t('message')}</p>
    </div>
  );
}
